import React from 'react';
import {History} from 'react-router';
import Tabs from 'material-ui/Tabs/Tabs';
import {WithDeleteDialogZzFlatButton, ZzFlatButton, ZzFlatButtonRoute} from "core/components/buttons/buttons";
import Tab from 'material-ui/Tabs/Tab';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import PageAncestor from 'core/common/page/pageAncestor';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {ZzIconButtonMenu, ZzIconButtonRoute, ZzMenuItem} from "core/components/buttons/icons";
import mdEntityService from 'core/metamodel/mdEntityService';
import partyService from 'party/partyService';
import {TabTemplate} from 'core/common/config/mui-theme';
import {tabStyle} from 'core/common/config/variables';
import {IDomainObject, lovLabel, lovParam, lovValue, preSave} from 'core/form/formUtils';
import PartyFoForm from 'party/component/partyFoForm';
import PartyPoForm from 'party/component/partyPoForm';
import PartyRelForm from 'party/component/partyRelForm';
import PartyContactList from 'party/component/partyContactList';
import PartyRoleForm from 'party/component/partyRoleForm';
import PartyNoteList from 'party/component/partyNoteList';
import PartyFeatureList from "party/component/partyFeatureList";
import PartyAddressList from 'party/component/partyAddressList';
import {ErrorComp} from 'core/components/errorComp/errorComp';
import Grid, {GridLocation} from 'core/grid/domain/grid';
import gridService from 'core/grid/gridService';
import GridComp, {BULKACTIONTYPE} from 'core/grid/component/gridComp';
import ConfirmationDialog from 'core/components/confirmationDialog/confirmationDialog';
import ProductVehicleAssignDialog from "product/component/productVehicleAssignDialog";
import {handleFavicon} from 'core/common/utils/favicon';
import {MdBlockArray} from "core/components/blockComp/blockComp";
import Add from "material-ui/svg-icons/content/add";
import {MODULE, PageProps, PERMISSION, SECURABLE, SECURABLE_TYPE} from "core/metamodel/metaConstant";
import {
  ADDRESSTYPE,
  Party,
  PartyBankAccount,
  PARTYCATEGORY,
  PARTYCONTACTCATEGORY,
  PartyFeature,
  PARTYFEATURETYPE,
  PartyNote,
  PARTYNOTETYPE,
  PartyRel,
  PartyRole,
  PARTYROLE,
  PartyRoleTypeStruct
} from "party/partyDomain";
import {default as MdEntity, LovItem} from "core/metamodel/mdEntity";
import {MovingBlocks} from "core/grid/gridUtils";
import {action, observable, ObservableMap} from "mobx";
import {observer} from "mobx-react";
import uiService from "core/common/service/uiService";
import {removeItem, toArray} from "core/common/utils/arrayUtils";
import VehicleExpando from "product/component/vehicleExpando";
import ActivityExpando from "core/event/component/activityExpando";
import {PRICECOMPLEVEL} from "product/productDomain";
import SvgMoreVert from "material-ui/svg-icons/navigation/more-vert";
import TaskDialog from "core/event/component/taskDialog";
import {ACTIVITYLOCATION, PartyActivity, TASKTYPE} from "core/event/eventDomain";
import {GridDocument} from "core/document/gridDocument";
import GridDocumentComp from "core/document/component/gridDocumentComp";
import commonService from "core/common/service/commonService";
import validator from 'validator'
import PartyBankAccountList from "party/component/partyBankAccountList";
import {PartyCreditEntryDto} from "accounting/accountingDomain";
import {PartyCreditEntryTable, PartyCreditSumTable} from "party/component/partyCreditEntry";
import {green500} from "material-ui/styles/colors";
import {classNames} from "core/common/utils/domUtils";
import IconButton from "material-ui/IconButton";
import FontIcon from "material-ui/FontIcon";
import {addTenantToQuery} from "core/common/utils/utils";
import securityService from "core/security/securityService";
import {PAGE} from "routes";
import {SHIPMENTDIRECTION} from "shipment/shipmentDomain";
import {loc} from "core/common/config/locales";
import {RESTRICTION} from "core/security/securityDomain";


const vehicleGridLocation = 'partyVehicleList';
const invoiceGridLocation = 'partyInvoiceList';
const invoiceItemGridLocation = 'partyInvoiceItemList';
const partyRelGridLocation = 'partyRelList';
const partyPriceComponentGridLocation = "partyPriceComponentList";
const partyActivityGridLocation = "partyActivityPartyList";
const taskGridLocation = "taskPartyList";
const partyGridDocument = 'partyGridDocument';
const shipmentGridLocation = 'partyShipmentList';

interface PartyDetailProps {
  relTypes: PartyRoleTypeStruct[];
}


function hasGridRight(module: MODULE, gridLocation: string): boolean {
  return securityService.hasRight(lovValue(gridService.gridLocationMap.get(gridLocation).securable), PERMISSION.Read);
}


@observer
export default class PartyDetail extends PageAncestor<PageProps, PartyDetailProps> {

  static module = MODULE.party;
  static protectedPage = true;


  static reinitMovingBlocks(partyObject: Party) {
    let standaloneBlockName =  taskGridLocation;

    let blockNames: string[] = [taskGridLocation, partyActivityGridLocation, partyRelGridLocation, partyGridDocument];

    if (securityService.currentUser.hasRestriction(RESTRICTION.YARD_MGMT_HAULER_DRIVER)) {
      removeItem(blockNames, partyRelGridLocation);
    }

    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE)) {
      if (hasGridRight(MODULE.invoicing, invoiceItemGridLocation)) blockNames.unshift(invoiceItemGridLocation);
      if (hasGridRight(MODULE.invoicing, invoiceGridLocation)) blockNames.unshift(invoiceGridLocation);
      if (hasGridRight(MODULE.product, partyPriceComponentGridLocation)) blockNames.push(partyPriceComponentGridLocation);
    }

    if (partyObject.hasOneOfRoles(PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE, PARTYROLE.OPERATOR, PARTYROLE.SUPPLIER_ROLE)) {
      if (hasGridRight(MODULE.shipment, shipmentGridLocation)) blockNames.unshift(shipmentGridLocation);
    }

    if (partyObject.hasOneOfRoles(PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE, PARTYROLE.OPERATOR)) {
      if (hasGridRight(MODULE.product, vehicleGridLocation)) {
        standaloneBlockName = vehicleGridLocation;
        blockNames.unshift(vehicleGridLocation);
      }
    }

    partyObject.$movingBlocks.reinit(standaloneBlockName, blockNames)
  }

  static fetchData(routerParams, query) {
    console.log("PartyDetail#fetchData(%O)", query);

    let entityMap;

    return mdEntityService.fetchEntityMetadata(['Party', 'PartyContact', 'PartyRole', 'Address', 'PartyRel', 'PartyNote', 'PartyFeature', "Contract", "PartyBankAccount", "Bank"],
      [{entity: 'PARTYCONTACTCATEGORY', lov: true}, {entity: 'PARTYFEATURETYPE', lov: true}, {entity: 'AddressPlace', lov: true}, {entity: 'PARTYCATEGORY', lov: true}, {entity: 'DOCUMENTATTACHMENTTYPE', lov: true}, 'Document'])
      .then(_entityMap => {
        entityMap = _entityMap;
        let partyPromise: Promise<Party>;
        if (routerParams.id === 'new') {
          let {roles, ...q} = query;
          let partyRoles: PartyRole[] = toArray(roles).map(r => partyService.newRole(parseInt(r)));
           if (q.defaultSendType) {
             q.defaultSendType = entityMap.get('SENDTYPE').getLovItem(q.defaultSendType);
           }
          partyPromise = Promise.resolve(new Party({active: true, $new: true, ...q, roles: partyRoles}));
        } else if (routerParams.id === 'copy') {
          partyPromise = partyService.readParty(query.copyId)
            .then(partyObject => {
              partyObject.cleanOnCopy();
              partyObject.active = true;

              partyObject.contacts.forEach(c => {
                c.partyContactId = null;
                c.party = null;
              });
              partyObject.roles.forEach(r => {
                r.partyRoleId = null;
                r.party = null;
              });
              partyObject.notes.forEach(n => {
                n.partyNoteId = null;
                n.party = null;
              });
              partyObject.features.forEach(n => {
                n.partyFeatureId = null;
                n.party = null;
              });
              partyObject.addresses.forEach(a => {
                a.addressId = null;
                a.party = null;
              });
              return partyObject;
            })
        } else {
          partyPromise = partyService.readParty(routerParams.id);
        }

        let gridPromise = gridService.fetchGrids(vehicleGridLocation, invoiceGridLocation, invoiceItemGridLocation, partyRelGridLocation, partyPriceComponentGridLocation, taskGridLocation, partyActivityGridLocation, shipmentGridLocation);

        return Promise.all([partyPromise, gridPromise]);
      })
      .then(([partyObject, gridLocationMap]: [Party, ObservableMap<GridLocation>]) => {


        partyObject.$movingBlocks = new MovingBlocks(null, true, query.tab,
          new Grid(gridLocationMap.get(vehicleGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(shipmentGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(invoiceGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(invoiceItemGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(taskGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(partyActivityGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(partyRelGridLocation), partyObject.partyId),
          new Grid(gridLocationMap.get(partyPriceComponentGridLocation), partyObject.partyId),
          new GridDocument(partyGridDocument, "Docs", {partyId: partyObject.partyId}, true, partyObject, (partyObject.$new)?[]:null),
        );

        PartyDetail.reinitMovingBlocks(partyObject);


        partyService.partyObject = partyObject.initAfterRead(routerParams.id === 'new');

        // override podle customer x contact person x sales rep x user
        document.title = partyObject.roleName();
        handleFavicon(partyObject.partyIcon());
      });
  }


  private productVehicleAssignDialogRef: ProductVehicleAssignDialog;
  private vehicleTaskDialogRef: TaskDialog;
  private taskDialogRef: TaskDialog;
  private confirmationDialogRef: ConfirmationDialog;
  @observable creditEntriesExpanded: boolean;

  state = {relTypes: []};




  /**
   *
   */
  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }


  componentDidUpdate(prevProps: PageProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      partyService.partyObject.$movingBlocks.searchExposedGrids(partyService.partyObject);
    }
  }



  componentDidMount() {
    partyService.partyObject.$movingBlocks.searchExposedGrids(partyService.partyObject);

    if (partyService.partyObject.partyId) {
      partyService.readCreditEntries(partyService.partyObject.partyId)
        .then(action("readCreditEntriesACB", (data: PartyCreditEntryDto) => {
          partyService.partyObject.$creditEntries = data.entries;
          partyService.partyObject.$creditSums = data.sums;
        }));
    }
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    partyService.partyObject = null;
  }




  customValidate = (partyObject: Party) => {
    let errors = [];
    if (partyObject.roles.length === 0) {
      errors.push({message: "Party must have at least one role"})
    }
    let numberOfPermanentAddresses = partyObject.addresses.filter(a => lovValue(a.addressType) === ADDRESSTYPE.PERMANENT).length;
    if (numberOfPermanentAddresses > 1) {
      errors.push({message: "Party must have only one Permanent Address"})
    }
    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE) && numberOfPermanentAddresses === 0) {
      errors.push({message: "Party with role Customer must have Permanent Address"})
    }

    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultCurrency) {
      errors.push({message: "Party with role Customer must have default currency"})
    }

    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultSendType) {
      errors.push({message: "Party with role Customer must have default send type"})
    }
    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE) && !partyObject.defaultAttachmentType) {
      errors.push({message: "Party with role Customer must have default attachment type"})
    }

    if (partyObject.addresses.filter(a => lovValue(a.addressType) === ADDRESSTYPE.CORRESPONDENT).length > 1) {
      errors.push({message: "Party must have only one Correspondent Address"})
    }

    if (partyObject.getInvoicingPeriod() && !partyObject.getInvoicingStartDate()) {
      errors.push({message: "If Invoicing Period is bigger than 1 month, Invoice start Date must be specified to fix start of this period"})
    }

    if (partyObject.partyCategory === PARTYCATEGORY.EN && (!partyObject.lastName || !partyObject.firstName)) {
      errors.push({message: "Party must have Last and First name filled in"})
    }

    if (partyObject.notes.filter(n => lovValue(n.noteType) === PARTYNOTETYPE.INVOICE).length > 1) {
      errors.push({message: `There is allowed only 1 ${PARTYNOTETYPE.INVOICE} note for party`})
    }

    let badContacts = partyObject.contacts.filter(pc => pc.contactType.category === PARTYCONTACTCATEGORY.EMAIL && !validator.isEmail(pc.value));
    for(let pc of badContacts) errors.push({message: lovLabel(pc.contactType) + " Contact " + pc.value + " has invalid format"})

    return errors;
  };

  findRootObject() {
    return partyService.partyObject;
  }


  @action onSave = (evt) => {
    console.log('onSave %O', partyService.partyObject);
    uiService.showToolbarActionFlag();

    let result = preSave(partyService.partyObject, this.customValidate);
    if (!result) {
      return;
    }

    let wasNew: boolean;

    return partyService.partySave(partyService.partyObject.createDataObjectDto())
      .then(action("partySave-action", (partyJson: IDomainObject) => {
        wasNew = partyService.partyObject.cleanAfterSave(partyJson);
        return this.docSavingPromise(partyService.partyObject.$movingBlocks.getBlock(partyGridDocument) as GridDocument, {partyId: partyService.partyObject.partyId})
      })).then(x => {
        if (wasNew) {
          this.context.router.replaceWith('partyDetail', {id: partyService.partyObject.partyId});
        }
        uiService.hideToolbarActionFlag();
    }).catch(error => {
      partyService.partyObject.$errors = error.getMessages();
    });

  };




  @action onDelete = (evt) => {
    console.log('onDelete');
    uiService.showToolbarActionFlag();

    partyService.deleteParty(partyService.partyObject.partyId)
      .then(response => {
        uiService.hideToolbarActionFlag();
        this.goBackOrHome();
      }, error => {
        partyService.partyObject.$errors = error.getMessages();
      });
  };


  onAdd = (evt) => {
    console.log('onAdd');
    let query: any = {partyCategory: partyService.partyObject.partyCategory};
    query.roles = partyService.partyObject.roles.filter(ro => lovValue(ro.roleType) <= 3).map(ro => ro.roleType.value);
    this.context.router.transitionTo("partyDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("partyDetail", {id: 'copy'}, {copyId: partyService.partyObject.partyId});
  };

  @action addPartyRel = (relType: PartyRoleTypeStruct) => {
    console.log('addPartyRel ', relType);
    let grid: Grid = partyService.partyObject.$movingBlocks.getBlock(partyRelGridLocation) as Grid;
    let rowObject = new PartyRel({
      relType: relType,
      $new: true,
      $dirty: true,
      $added: true,
      [(relType.directionFrom) ? "fromParty" : "toParty"]: partyService.partyObject.partyLov()
    }).initDefaultValues();
    grid.addRow(rowObject);
    let form = rowObject.getForm('PartyRelForm');
    form.$open = true;

    partyService.partyObject.$dirty = true;
  };

  @action openAddRel = () => {
    console.log('Open add rel');

    let roleTypes: LovItem[] = partyService.partyObject.roles.map(r => r.roleType);
    let allRelTypes: LovItem[] = mdEntityService.getEntity("PartyRelType").lovItems;
    let roleTypeEntity: MdEntity = mdEntityService.getEntity("PartyRoleType");
    let relTypes: PartyRoleTypeStruct[] = [];

    for(let relType of allRelTypes) {
      let fromRoleId: number = lovParam(relType, "from");
      let toRoleId: number = lovParam(relType, "to");
      let fromRoleType: LovItem = roleTypes.find((rt => lovValue(rt) === fromRoleId));
      let toRoleType: LovItem = roleTypes.find((rt => lovValue(rt) === toRoleId));

      if (fromRoleType || toRoleType) {

        let o: PartyRoleTypeStruct = Object.assign({}, relType as any);
        if (fromRoleType) {
          o.directionFrom = true;
          o.roleLabel = roleTypeEntity.getLovItemLabel(toRoleId);
          o.roleId = toRoleId;
        } else {
          o.roleLabel = roleTypeEntity.getLovItemLabel(fromRoleId);
          o.roleId = fromRoleId;
        }
        // musime vyloucit protoze existuji CONTACT_PERSON -> CUSTOMER, CONTACT_PERSON -> OPERATOR, tak aby nebyly 2 nabidky pri vazbeni z customera, ktery je zaroven operator
        if (!relTypes.find(relType => relType.roleId === o.roleId)) {
          relTypes.push(o);
        }
      }
    }

    this.setState({relTypes});
  };

  @action addNote = (evt) => {
    console.debug('addNote');
    let newNote = new PartyNote({$new: true, $added: true}).initDefaultValues();
    partyService.partyObject.notes.push(newNote);
    partyService.partyObject.$dirty = true;
  };



  @action addBankAccount = () => {
    console.debug('add PartyBankAccount');
    let newAccount = new PartyBankAccount({$new: true, $added: true}).initDefaultValues();
    partyService.partyObject.bankAccounts.push(newAccount);
    partyService.partyObject.$dirty = true;
  };


  @action addFeature = (feature) => {
    console.log('addBankInfo %s', feature);
    let newFeature = new PartyFeature({$new: true, $added: true, featureType: feature}).initDefaultValues();
    partyService.partyObject.features.push(newFeature);
    partyService.partyObject.$dirty = true;
  };


  @action assignProducts = (grid: Grid) => {
    new Promise((resolve, reject) => {
      this.productVehicleAssignDialogRef.open(resolve, reject, grid);
    }).catch( (e) => {})
  };
  @action createTasks = (grid: Grid) => {
    console.log('createTasks');
    return new Promise((resolve, reject) => {
      return this.vehicleTaskDialogRef.open(resolve, reject, grid.createFullParams());
    }).catch( (e) => {});
  };

  @action onChangeRole = () => {
    PartyDetail.reinitMovingBlocks(partyService.partyObject);
    partyService.partyObject.$movingBlocks.searchExposedGrids(partyService.partyObject);
  };

  @action onCustomerNotification = (evt) => {
    console.log('onCustomerNotification');
    new Promise((resolve, reject) => {
      this.taskDialogRef.open(resolve, reject, {entity: partyService.partyObject.$mdEntityRef.id, rowid: [partyService.partyObject.partyId]});
    }).then(() => {
      uiService.hideToolbarActionFlag();
      let movingBlocks = partyService.partyObject.$movingBlocks;
      let taskGrid: Grid = movingBlocks.getBlock(taskGridLocation) as Grid;
      taskGrid.data = null;
      if (movingBlocks.activeBlockTab === taskGridLocation) {
        this.activateTab(taskGrid);
      }

    }).catch((e) => {
    })
  };

  @action onCustomerRegistration = (evt) => {
    console.log('onCustomerRegistration');

    new Promise((resolve, reject) => {
      this.confirmationDialogRef.open(resolve, reject, 'Do you really want to send registration emails for this customer ?');
    }).then(() => {
      uiService.showToolbarActionFlag();

      return partyService.manualCustomerRegistration(partyService.partyObject.partyId)
        .then((activities: PartyActivity[]) => {
          if (activities.length) {
            commonService.notifyInfo("Registration emails were sent.", null, (
                <ul>
                  {activities.map(activity => (
                    <li>
                      {activity.emailSubject} - To: {activity.getTo().join(", ")} , Cc: {activity.getCc().join(", ")}
                    </li>
                  ))}
                </ul>
            ), 0);
          } else {
            commonService.notifyWarning("No Registration email was sent, there is probably no contact person with Email Registration Role or no active vehicle with configured products.");
          }

          uiService.hideToolbarActionFlag();
        });

    }).catch((e) => {
    });



  };


  @action expandCreditEntries = () => {
    this.creditEntriesExpanded = !this.creditEntriesExpanded;
  };



  productVehicleAssignDialogRefHandler = (comp) => this.productVehicleAssignDialogRef = comp;
  taskDialogRefHandler = comp => this.taskDialogRef = comp;
  vehicleTaskDialogRefHandler = comp => this.vehicleTaskDialogRef = comp;
  confirmationDialogRefHandler = comp => this.confirmationDialogRef = comp;

  render() {

    let {
      query
      } = this.props;

    let propsForCreateForm = {
      dataObject: partyService.partyObject,
      rootObject: partyService.partyObject,
      entity: mdEntityService.getEntity('Party'),
      entities: mdEntityService.entityMap
    };

    let partyObject = partyService.partyObject;

    let movingBlocks = partyService.partyObject.$movingBlocks;

    console.debug('%c partyDetail render query %O', 'background-color: yellow', this.props.query);

    const verticalArray = [(partyObject.partyCategory === PARTYCATEGORY.PE) ? <PartyFoForm {...propsForCreateForm} key={1} /> : <PartyPoForm {...propsForCreateForm} key={1} /> ];
    verticalArray.push(<PartyAddressList partyObject={partyObject} entities={mdEntityService.entityMap} key={2}/>);
    if (partyObject.bankAccounts && partyObject.bankAccounts.length) verticalArray.push(
      <PartyBankAccountList partyObject={partyObject} rootObject={partyObject} entities={mdEntityService.entityMap} key={3} />);
    if (partyObject.features && partyObject.features.length) verticalArray.push(
      <PartyFeatureList partyObject={partyObject} rootObject={partyObject} entities={mdEntityService.entityMap} key={4}/>);
    if (partyObject.notes && partyObject.notes.length) verticalArray.push(
      <PartyNoteList partyObject={partyObject} rootObject={partyObject} entities={mdEntityService.entityMap} key={5}/>);

    const mainForm = (
      <form style={{marginTop: 10}}>

        {(partyObject.$creditSums && partyObject.$creditSums.length) ? (
          <div style={{display: 'flex', paddingLeft: 20}}>
            <PartyCreditSumTable sums={partyObject.$creditSums}/>
            <IconButton  style={{width:40, height: 40, marginTop:4}} iconStyle={{fontSize: 20}} onClick={this.expandCreditEntries} >
              <FontIcon color={green500} className={classNames('fa', {'fa-angle-double-down': !this.creditEntriesExpanded, 'fa-angle-double-up': this.creditEntriesExpanded})} />
            </IconButton>
          </div>
        ) : null}

        {(this.creditEntriesExpanded && partyObject.$creditEntries && partyObject.$creditEntries.length) ? (
          <PartyCreditEntryTable creditEntries={partyObject.$creditEntries}/>
        ) : null}


        <div className="row">
          <MdBlockArray className="col-xs-12 col-sm-8 block-comp-right-border" inset>
            { verticalArray }
          </MdBlockArray>

          {/* <MdVerticalDivider inset/>  -- breaks responsive design spolu s nowrap*/}

          <div className="col-xs-12 col-sm-4">
            <PartyContactList partyObject={partyObject} rootObject={partyObject} entities={mdEntityService.entityMap} />
            <PartyRoleForm onChangeRole={this.onChangeRole} dataObject={partyObject} rootObject={partyObject}
                           entity={mdEntityService.getEntity("PartyRole")} entities={mdEntityService.entityMap} />
          </div>
        </div>
      </form>
    );


    const rowPartyRelForm = (
      <PartyRelForm rootObject={partyObject} entity={mdEntityService.getEntity('PartyRel')} entities={mdEntityService.entityMap} dataObject={null} />
    );


    const gridCompArray = [<GridComp grid={movingBlocks.getBlock(taskGridLocation) as Grid} key="taskGridLocation"
                                     uiLocation={movingBlocks.getUiLocation(taskGridLocation)}
                                     entities={mdEntityService.entityMap}/>];

    gridCompArray.push(<GridComp grid={movingBlocks.getBlock(partyActivityGridLocation) as Grid} key="partyActivityGridLocation"
                                 uiLocation={movingBlocks.getUiLocation(partyActivityGridLocation)}
                                 entities={mdEntityService.entityMap} showExpand ExpandComponent={ActivityExpando}/>);

    if (movingBlocks.getBlock(partyRelGridLocation)) {
      gridCompArray.push(<GridComp grid={movingBlocks.getBlock(partyRelGridLocation) as Grid} key="partyRelGridLocation"
                                   uiLocation={movingBlocks.getUiLocation(partyRelGridLocation)}
                                   showDelete={true} deleteRowIcon="fa fa-chain-broken"
                                   rootObject={partyObject}
                                   showEdit={true} editForm={rowPartyRelForm} editFormName="PartyRelForm"
                                   entities={mdEntityService.entityMap} hideCopyRow
                                   multiUpdateSecurable={SECURABLE.partyGridUpdate} multiUpdateSaveFn={this.onSave}>
        <ZzIconButtonMenu onClick={this.openAddRel} buttonIcon={<Add/>}>
          {
            this.state.relTypes.map(relType => <MenuItem key={lovValue(relType)} primaryText={relType.roleLabel} onClick={this.addPartyRel.bind(this, relType)}/>)
          }
        </ZzIconButtonMenu>
      </GridComp>);
    }


    if (partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE)) {
      if (hasGridRight(MODULE.invoicing, invoiceItemGridLocation)) gridCompArray.unshift(<GridComp grid={movingBlocks.getBlock(invoiceItemGridLocation) as Grid}
                                      uiLocation={movingBlocks.getUiLocation(invoiceItemGridLocation)}
                                      entities={mdEntityService.entityMap}/>);
      if (hasGridRight(MODULE.invoicing, invoiceGridLocation)) gridCompArray.unshift(<GridComp grid={movingBlocks.getBlock(invoiceGridLocation) as Grid}
                                      uiLocation={movingBlocks.getUiLocation(invoiceGridLocation)}
                                      entities={mdEntityService.entityMap}>
        <ZzIconButtonRoute big routeName="invoiceDetail" params={{id: 'new'}}
                           query={{partyId: partyObject.partyId, paymentTypeId: 1}}
                           disabled={partyObject.$new}>
           <Add/>
          </ZzIconButtonRoute>
      </GridComp>);
      if (hasGridRight(MODULE.product, partyPriceComponentGridLocation)) gridCompArray.push(<GridComp grid={movingBlocks.getBlock(partyPriceComponentGridLocation) as Grid}
                                   uiLocation={movingBlocks.getUiLocation(partyPriceComponentGridLocation)}
                                   entities={mdEntityService.entityMap}>
        <ZzIconButtonRoute big routeName="priceComponentDetail" params={{id: 'new'}}
                           query={{partyId: partyObject.partyId, partyLabel: partyObject.partyLabel(), priceLevel: PRICECOMPLEVEL.PRODUCTCUSTOMER, priceCurrency: lovValue(partyObject.defaultCurrency)}}
                           disabled={partyObject.$new}>
          <Add/>
        </ZzIconButtonRoute>
      </GridComp>)
    }
    if (partyObject.hasOneOfRoles(PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE, PARTYROLE.OPERATOR, PARTYROLE.SUPPLIER_ROLE)) {
      if (hasGridRight(MODULE.shipment, shipmentGridLocation)) gridCompArray.unshift(<GridComp  grid={movingBlocks.getBlock(shipmentGridLocation) as Grid}
                                       uiLocation={movingBlocks.getUiLocation(shipmentGridLocation)}
                                       entities={mdEntityService.entityMap}
                                       multiUpdateSecurable={SECURABLE.shipmentGridUpdate}>
        <ZzIconButtonRoute big routeName="shipmentDetail" params={{id: 'new'}}
                           query={{partyId: partyObject.partyId, partyLabel: partyObject.partyLabel()}}
                           disabled={partyObject.$new}>
          <Add/>
        </ZzIconButtonRoute>

        <ZzFlatButtonRoute onGridToolbar routeName="shipmentDetail" params={{id: 'new'}} query={{shipmentDirection: SHIPMENTDIRECTION.OUTGOING, partyId: partyObject.partyId, partyLabel: partyObject.partyLabel()}}
                           label={loc.i18n`New Out Shipment`} disabled={partyObject.$new} permission={PERMISSION.New} securable={PAGE.shipmentDetail}/>
        <ZzFlatButtonRoute onGridToolbar routeName="shipmentDetail" params={{id: 'new'}} query={{shipmentDirection: SHIPMENTDIRECTION.INCOMING, partyId: partyObject.partyId, partyLabel: partyObject.partyLabel()}}
                           label={loc.i18n`New In Shipment`} disabled={partyObject.$new} permission={PERMISSION.New} securable={PAGE.shipmentDetail}/>

      </GridComp>);
    }
    if (partyObject.hasOneOfRoles(PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE, PARTYROLE.OPERATOR)) {
      if (hasGridRight(MODULE.product, vehicleGridLocation)) gridCompArray.unshift(<GridComp  grid={movingBlocks.getBlock(vehicleGridLocation) as Grid}
                                                                                              uiLocation={movingBlocks.getUiLocation(vehicleGridLocation)}
                                                                                              entities={mdEntityService.entityMap} showExpand ExpandComponent={VehicleExpando}
                                                                                              multiUpdateSecurable={SECURABLE.productGridUpdate}
                                                                                              bulkActions={[
                                                                                                {type: BULKACTIONTYPE.ACTION, label: 'Assign Product', fn: this.assignProducts},
                                                                                                {type: BULKACTIONTYPE.ACTION, label: 'Create Tasks', fn: this.createTasks}
                                                                                              ]} >
        <ZzIconButtonRoute big routeName="vehicleDetail" params={{id: 'new'}}
                           query={{partyId: partyObject.partyId, partyLabel: partyObject.partyLabel(), vehicleType: 1}}
                           disabled={partyObject.$new}>
          <Add/>
        </ZzIconButtonRoute>
        <ProductVehicleAssignDialog ref={this.productVehicleAssignDialogRefHandler} />
        <TaskDialog ref={this.vehicleTaskDialogRefHandler} entities={mdEntityService.entityMap} location={ACTIVITYLOCATION.Vehicle} taskType={TASKTYPE.VEHICLE_NOTIFICATION}/>
      </GridComp>);
    }

    gridCompArray.push(<GridDocumentComp uiLocation={movingBlocks.getUiLocation(partyGridDocument)} grid={movingBlocks.getBlock(partyGridDocument) as GridDocument}
                                         entities={mdEntityService.entityMap} rootObject={partyObject}/>);


    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle}
           onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}
           value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));

    const tabs = (tabArray.length) ? (
      <Tabs value={movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate}
            inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange}>
        {tabArray}
      </Tabs>
    ) : null;


    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}}>
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(partyObject, query.gridLocation, mdEntityService.getEntity('PARTYFEATURETYPE'))}
            <ErrorComp messages={partyObject.$errors}/>
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            <ConfirmationDialog okButtonText="Yes" cancelButtonText="No" ref={this.confirmationDialogRefHandler}/>
            <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
            <TaskDialog ref={this.taskDialogRefHandler} entities={mdEntityService.entityMap} location={ACTIVITYLOCATION.Customer} taskType={TASKTYPE.PARTY_NOTIFICATION}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}}>
          {this._createToolMenu(partyObject, query.gridLocation, mdEntityService.getEntity('PARTYFEATURETYPE'))}
          <ErrorComp messages={partyObject.$errors}/>
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog okButtonText="Yes" cancelButtonText="No" ref={this.confirmationDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          <TaskDialog ref={this.taskDialogRefHandler} entities={mdEntityService.entityMap} location={ACTIVITYLOCATION.Customer} taskType={TASKTYPE.PARTY_NOTIFICATION}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }

  _createToolMenu(partyObject: Party, gridLocation: string, PARTYFEATURETYPE: MdEntity) {
    let featureTypes: string[] = partyObject.features.map(f => f.featureType);
    let placesUrl = (partyObject.partyId) ? this.context.router.makeHref("addressPlacesList", {id: partyObject.partyId}, addTenantToQuery()) : null;

    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} historize
                entityName="Party" entityId={partyObject.partyId} activeTab={partyObject.$movingBlocks.activeBlockTab}>

        <ZzFlatButton onClick={this.onSave} disabled={!partyObject.$dirty} label="Save" permission={partyObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={partyObject.$new} label="New" permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={partyObject.$new} label="Copy" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="Party" pageAncestor={this} onClick={this.onDelete} disabled={partyObject.$new} label="Delete" permission={PERMISSION.Delete}/>


        <ZzIconButtonMenu buttonIcon={<Add/>} >
          <MenuItem primaryText="Add Note"  onClick={this.addNote}/>
          <MenuItem primaryText="Add Bank Info"  onClick={this.addBankAccount}/>
          <Divider/>
          {PARTYFEATURETYPE.lovItems.filter(f => !featureTypes.includes(f.value as string) && f["visible"]).map( (lovItem, index) => <MenuItem primaryText={lovItem.label} key={index} onClick={this.addFeature.bind(this, lovItem.value)}/> )}
        </ZzIconButtonMenu>

        <ZzIconButtonMenu buttonIcon={<SvgMoreVert/>} securableType={SECURABLE_TYPE.DETAILACTION}>
          {(!partyObject.$new && partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE)) ? (
            <ZzMenuItem primaryText="Create Task" key={4} onClick={this.onCustomerNotification} securable={SECURABLE.customerNotification}/>
          ) : null}
          {(!partyObject.$new && partyObject.hasRole(PARTYROLE.CUSTOMER_ROLE)) ? (
            <ZzMenuItem primaryText="Customer Registration" key={5} onClick={this.onCustomerRegistration} securable={SECURABLE.customerRegistration}/>
            ) : null}

          { (placesUrl) ? <ZzMenuItem primaryText="Address Places" href={placesUrl} onClick={this.onAddressPlaces} /> : null}
        </ZzIconButtonMenu>


      </Toolmenu>
    );
  }

  @action onAddressPlaces = (event) => {
    console.log('places');
    event.preventDefault();
    this.context.router.transitionTo("addressPlacesList", {id: partyService.partyObject.partyId}, addTenantToQuery());
  } ;

}




// WEBPACK FOOTER //
// ./src/party/page/partyDetail.tsx